import { BeeModel } from "../../beeorm/BeeModel";
import { BeeModelCollection } from "../../beeorm/BeeModelCollection";
import { BookModel } from "./BookModel";
import type { BookModelManagerOptions } from "../modelManager.types";

export class BookModelCollection<
  T extends BeeModel = BookModel,
  C extends object = object,
  O extends BookModelManagerOptions = BookModelManagerOptions,
> extends BeeModelCollection<T, C, O> {
  hasAllIds(ids: number[]) {
    return ids.every((id) => this.findById(`${id}`));
  }

  getAsSelectOptions({ label = "title", value = "id" } = {}) {
    return this.all().map((model) => ({
      label: model.get<string>(label)!,
      value: "" + model.get(value),
    }));
  }
}
